import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint react/prop-types: 0 */
import { useState } from 'react';
import { withCookies } from 'react-cookie';
import { DialogStyled } from '@nike/nike-design-system-components';
import { useStadium } from 'stadium/StadiumHooks';
import { NotificationContent } from './NotificationContent';
import NotificationFooterButtons from './NotificationFooterButtons';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Notification = function Notification(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useStadium = useStadium(),
    sendInteractionEvent = _useStadium.analyticsHooks.sendInteractionEvent;
  var toggleModal = function toggleModal(isAlwaysOn, cookies, cookieName) {
    if (isModalOpen && !isAlwaysOn) {
      cookies.set(cookieName, true, {
        path: '/',
        expires: new Date('Fri, 31 Dec 9999 23:59:59 GMT')
      });
    }
    setIsModalOpen(!isModalOpen);
  };
  var deleteCookies = function deleteCookies(cookies) {
    var xfPath = props.xfPath;
    Object.keys(cookies.getAll()).filter(function (item) {
      return item.startsWith(xfPath);
    }).forEach(function (item) {
      cookies.remove(item, {
        path: '/'
      });
    });
  };
  var display = function display() {
    var cookies = props.cookies,
      lastModified = props['cq:lastModified'],
      _props$xfPath = props.xfPath,
      xfPath = _props$xfPath === void 0 ? '' : _props$xfPath,
      isAuthor = props.isAuthor,
      _props$root = props.root,
      _props$root2 = _props$root === void 0 ? {} : _props$root,
      alwayson = _props$root2.alwayson,
      _props$root2$title = _props$root2.title,
      title = _props$root2$title === void 0 ? ' ' : _props$root2$title;
    var epoch = new Date(lastModified).getTime();
    var isAlwaysOn = alwayson === 'true';
    var cookieName = "".concat(xfPath, "-").concat(epoch);
    var isNotRead = !cookies.get(cookieName);
    if (!isAuthor && (isNotRead || isAlwaysOn)) {
      if (isAlwaysOn && cookies.get(cookieName)) deleteCookies(cookies);
      return /*#__PURE__*/_jsx("div", {
        id: "modal-root",
        "data-testid": "dialog-styled-div",
        children: /*#__PURE__*/_jsx(DialogStyled, {
          isOpen: isModalOpen
          // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
          ,
          closeModal: function closeModal() {
            sendInteractionEvent("homepage:notification:".concat(xfPath, ":X:closemodal"));
            toggleModal(isAlwaysOn, cookies, cookieName);
          },
          title: title,
          slots: {
            FooterSlot: /*#__PURE__*/_jsx(NotificationFooterButtons, _objectSpread(_objectSpread({}, props), {}, {
              closeModal: function closeModal() {
                toggleModal(isAlwaysOn, cookies, cookieName);
              }
            }))
          },
          placeholder: undefined,
          onPointerEnterCapture: undefined,
          onPointerLeaveCapture: undefined,
          children: /*#__PURE__*/_jsx(NotificationContent, _objectSpread({}, props))
        })
      });
    }
    if (isAuthor) {
      return /*#__PURE__*/_jsx(NotificationContent, _objectSpread({}, props));
    }
    return null;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: display()
  });
};
export default withCookies(Notification);